// appConfig (aka config.autoupdate) keys
export const AB_TEST_IDS = 'abtest.ids';
export const ADS_PERSONA = 'ads.persona';
export const PLAYER_TIMEOUT_MS = 'player.stream.timeoutMs';
export const PLAYER_ICY_METADATA_ENABLED = 'player.icyMetadata.enabled';
export const PLAYER_SUBSCRIPTION_QR_CODE_ENABLED = 'player.subscriptionQrCode.enabled';
export const PLAYER_SUBSCRIPTION_QR_CODE_IMAGE_URL = 'player.subscriptionQrCode.imageUrl';
export const PLAYER_SUBSCRIPTION_QR_CODE_LABEL_KEY = 'player.subscriptionQrCode.label.key';
export const SUBSCRIPTION_ENABLED = 'subscription.enabled';
export const L10N_DICTIONARY_URL = 'l10n.dictionaryUrl';
export const REJECTED_STREAMS_REASON_BLOCKLIST = 'player.rejectedStreams.reasonBlocklist';
export const PARTNER_ADS_CONFIG = 'ads.config.audioVideo';
export const VERBOSE_EVENT_REPORTING_ENABLED = 'player.verboseEventReporting.enabled';
// Key mistakenly references `display`, but it's a video setting for IMA
export const ADS_VIDEO_VPAID_MODE = 'ads.display.vpaidMode';
export const ADS_SMART_PREROLL_ENABLED = 'ads.smartPrerolls.enabled';
// boost
export const BOOST_ENABLED = 'boost.enabled';
export const BOOST_INTRO_AUDIO = 'boost.intro.audio';
export const BOOST_INTRO_PLAYSESSIONFREQCAP_COUNT = 'boost.intro.playsessionfreqcap.count';
export const BOOST_OUTRO_AUDIO = 'boost.outro.audio';
export const BOOST_OUTRO_PLAYSESSIONFREQCAP_COUNT = 'boost.outro.playsessionfreqcap.count';
// localization keys
export const AD_BREAK_TITLE = 'player.preroll.title';
export const PREROLL_SUBTITLE = 'player.preroll.subtitle';
export const MIDROLL_SUBTITLE = 'player.midroll.subtitle';
export const BOOST_INTRO_TITLE = 'boost.audio.intro.player.title';
export const BOOST_OUTRO_TITLE = 'boost.audio.outro.player.title';
export const fallbackValues = {
    [AD_BREAK_TITLE]: 'Advertising',
    [PREROLL_SUBTITLE]: 'Your content will start shortly...',
    [MIDROLL_SUBTITLE]: 'Your content will resume shortly...',
    [BOOST_INTRO_TITLE]: 'Enjoy less ads',
    [BOOST_OUTRO_TITLE]: 'Back to your live station',
};
// public constants below this line
export const PlayerStatus = {
    IDLE: 'IDLE',
    PLAYING: 'PLAYING',
    LOADING: 'LOADING',
    WAITING: 'WAITING',
    FAILED: 'FAILED',
};
